"use strict";

/* todo: I want this to actually be an array of Function | string but that causes errors */
if (typeof exports !== "undefined") Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_GlamorRule", {
  value: require("prop-types").shape({
    cssText: require("prop-types").string.isRequired
  })
});

/* eslint-disable no-undef */


/*****************
 ** WEBPACK FOOTER
 ** ./~/styled-components/lib/types.js
 ** module id = 9
 ** module chunks = 0
 **/